import clsx from "clsx";
import type React from "react";
import styles from "./badge.module.scss";

export interface BadgeProps {
  variant?: "primary" | "secondary" | "success" | "warning" | "error";
  size?: "small" | "medium" | "large";
  children: React.ReactNode;
  className?: string;
}

export const Badge: React.FC<BadgeProps> = ({
  variant = "secondary",
  size = "medium",
  children,
  className,
}) => {
  return (
    <span
      className={clsx(styles.badge, styles[variant], styles[size], className)}
    >
      {children}
    </span>
  );
};
